import { CommonUtilsService } from 'data/services/common-utils/common-utils.service';
import { CommonUtilsServiceInterface } from 'domain/services';
import { makeRemoteGetLastProductVersions } from 'main/factories/usecases/common-utils/remote-get-last-product-version-factory';

export const makeCommonUtilsService = (): CommonUtilsServiceInterface => {
  return new CommonUtilsService({
    getLastProductVersions: makeRemoteGetLastProductVersions(),
  });
};
